import { showInfo } from '@/notifications'

export const downloadFile = (url: string, name: string): void => {
  const link = document.createElement('a')
  link.href = url
  link.download = name
  link.click()

  showInfo('Начата загрузка файла')
}
